import React from 'react';
import { Checkbox } from '@mui/material';

import { StudySiteApi } from '../../../../../../api';
import { MANAGE_SSU_ON_HOLD } from '../../../../../../constants/userOperations';
import { userHasAccessTo } from '../../../../../../services/auth';

export default function SsuOnHoldCheckbox({ ssuId, onHold, onChange }) {
  const toggleOnHoldOption = () => {
    StudySiteApi.updateOnHoldOption(ssuId, !onHold).then(({ data }) => {
      onChange(data);
    });
  };

  return <Checkbox checked={onHold} disabled={!userHasAccessTo(MANAGE_SSU_ON_HOLD)} onChange={toggleOnHoldOption} />;
}
